export default __webpack_public_path__ + "static/20-6320daa04c6910147aeb6e3359de28e2.jpg";